































































































































































































































































































































































import {Component, Prop, Watch} from 'vue-property-decorator';
import {BusEvent} from '@/models/bus';
import Courses from "@/api/course";
import Topic from '@/api/topic';
import Skill from '@/api/skill';
import ApiList from '@/api/list';

import FieldImage from "@/components/FieldImage.vue";
import MultiDropdownEntity from '@/components/MultiDropdownEntity.vue';
import FieldInternational from '@/components/FieldInternational.vue';
import DropDownEntity from '@/components/DropDownEntity.vue';
import DropDownText from '@/components/DropDownText.vue';
import EditIcon from '@/components/icons/EditIcon.vue';
import {MediaFileField} from "@/models/fields";
import CommonVue from '@/models/commonVue';
import LockManager from '@/models/lock';
import { CourseStatusFields, CourseCertificateFields, CourseAvailabilityFields } from "@/api/common";

@Component({
    components: {
        'drop-down-entity': DropDownEntity,
        'drop-down-text': DropDownText,
        'field-international': FieldInternational,
        'edit-icon' : EditIcon,
        'field-image': FieldImage,
        'multi-dropdown-entity': MultiDropdownEntity,
    },
})
export default class EditCategory extends CommonVue {
    @Prop({type: Number}) public id?: number;
    public course: Courses = null;
    public courseName: string = '';
    public topics: ApiList<Topic> = null;
    public skills: ApiList<Skill> = null;
    
    public statusOptions = CourseStatusFields.OPTIONS;
    public statusPresentation = CourseStatusFields.PRESENTATION;
    
    public availabilityOptions = CourseAvailabilityFields.OPTIONS;
    public availabilityPresentation = CourseAvailabilityFields.PRESENTATION;
    
    public certificateOptions = CourseCertificateFields.OPTIONS;
    public certificatePresentation = CourseCertificateFields.PRESENTATION;

    public async beforeMount() {
        await this.load();
    }

    @Watch('id')
    public async load() {
        // this.busy = true;
        // this.error = false;

        // this.ignoreFirstEntityChange = true;
        await this.loadCourseList();
        await this.loadTopicList();
        await this.loadSkillList();
        // this.ignoreFirstEntityChange = false;
        this.updateName();

        // if (this.course && this.course.id) {
            // this.lockManager = new LockManager(this.COURSES_SLUG, this.course.id);
            // await this.lockManager.checkStatus();
            // if (this.lockManager.isBusy) {
                // this.$bus.$emit(
                //     BusEvent.ERROR,
                //     'Someone else is making changes.',
                //     new Error(
                //         'Click refresh to check if they have finished their changes'
                //     )
                // );
            // }
        // } else {
        //     this.lockManager = null;
        // }
        // this.busy = false;
    }

    public async loadCourseList(): Promise<void> {
        if (!this.id) {
            this.course = new Courses();
        } else {
            try {
                this.course = await Courses.get(this.id);
            }
            catch (e) {
                this.error = true;
                this.$bus.$emit(BusEvent.ERROR, 'Could not get course information', e);
            }
        }
    }

    public async loadTopicList() {
        try {
            this.topics = await Topic.listAll();
        } catch (e) {
            this.$bus.$emit(BusEvent.ERROR, 'Could not load topic list', e);
            this.error = true;
        }
    }

    public async loadSkillList() {
        try {
            this.skills = await Skill.getSkillOfCourse(true);
        } catch (e) {
            this.$bus.$emit(BusEvent.ERROR, 'Could not load skill list', e);
            this.error = true;
        }
    }

    public updateName() {
        let name = this.course.name.getDefaultValue();
        if (!name) {
            name = '';
        }
        this.courseName = name;
    }

    // enter edit mode if it can get the lock
    // @Watch('course', {deep: true})
    // public async enterEditMode() {
    //     await this.tryToLock();
    // }

    public async deleteClicked(): Promise<void> {
        if (!this.course || !this.course.id) {
            return;
        }
        this.busy = true;
        try {
            if (!this.lockManager){
                this.lockManager = new LockManager(this.COURSES_SLUG, this.course.id);
            }
            await this.tryToLock();
            await this.course.delete();
            await this.lockManager.releaseLock();
            this.busy = false;
            this.$router.push(`/${this.COURSES_SLUG}/`);
        }
        catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not delete course', e);
        }
    }

    public async saveClicked(): Promise<void> {
        console.log("saveClicked >>>>>");
        
        if (!this.course) {
            return;
        }
        this.busy = true;
        try {
            this.checkMandatoryFields();
            await this.saveCourse();

            this.busy = false;
            this.$router.push(`/${this.COURSES_SLUG}/${this.course.id}`);
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save course', e);
        }
    }

    public checkMandatoryFields() {
        if(!this.course){
            throw Error('Unable to create Course.');
        }

        // Check if name is filled
        const defaultName = this.course.name.getDefaultValue();
        if(defaultName === undefined || defaultName === '') {
            throw Error('Please insert an English name for your course.');
        }

        // Check if school field is filled
        // if(this.category.school === undefined || this.category.school === null) {
        //     throw Error('Please select a school.');
        // }
        const key_logo = 'logo';
        const logo_media = (this.$refs[key_logo] as any) as MediaFileField;
        if (!logo_media.hasMedia()) {
            throw Error('Please select a logo image.');
        }

        const key_entry_point_course_image = 'entry_point_course_image';
        const entry_point_course_image_media = (this.$refs[key_entry_point_course_image] as any) as MediaFileField;
        if (!entry_point_course_image_media.hasMedia()) {
            throw Error('Please select a entry_point_course_image image.');
        }

        const key_entry_point_bg = 'entry_point_bg';
        const entry_point_bg_media = (this.$refs[key_entry_point_bg] as any) as MediaFileField;
        if (!entry_point_bg_media.hasMedia()) {
            throw Error('Please select a entry_point_bg image.');
        }

        const key_promo_popup_course_image = 'promo_popup_course_image';
        const promo_popup_course_image_media = (this.$refs[key_promo_popup_course_image] as any) as MediaFileField;
        if (!promo_popup_course_image_media.hasMedia()) {
            throw Error('Please select a promo_popup_course_image image.');
        }
    }

    public async saveCourse(): Promise<void> {
        if (!this.course) {
            throw Error('Unable to save.');
        }
        const isNew = !this.course.id;
        if (!isNew) {
            console.log(`!isNew >> `, !isNew);
            
            if (!this.lockManager && this.course && this.course.id){
                this.lockManager = new LockManager(this.COURSES_SLUG, this.course.id);
            }
            await this.tryToLock();
            await this.saveMediaFiles();
        }
        await this.course.save();
        if (isNew) {
            await this.saveCourse();
        }
        if (this.lockManager && this.lockManager.isLocked) {
            await this.lockManager.releaseLock();
        }
    }

    public async saveMediaFiles(): Promise<void> {
        if (!this.course || !this.course.id) {
            throw Error('Course has not been created yet.');
        }

        const logo = await this.saveMediaFile(this.$refs.logo, 'logo');
        if (logo !== null) {
            this.course.logo = logo;
        }
        
        const mini_logo = await this.saveMediaFile(this.$refs.mini_logo, 'mini_logo');
        if (mini_logo !== null) {
            this.course.mini_logo = mini_logo;
        }

        const entry_point_course_image = await this.saveMediaFile(this.$refs.entry_point_course_image,'entry_point_course_image');
        if (entry_point_course_image !== null) {
            this.course.entry_point_course_image = entry_point_course_image;
        }
        
        const entry_point_bg = await this.saveMediaFile(this.$refs.entry_point_bg,'entry_point_bg');
        if (entry_point_bg !== null) {
            this.course.entry_point_bg = entry_point_bg;
        }
       
        const promo_popup_course_image = await this.saveMediaFile(this.$refs.promo_popup_course_image,'promo_popup_course_image');
        if (promo_popup_course_image !== null) {
            this.course.promo_popup_course_image = promo_popup_course_image;
        }

        const cert_bg = await this.saveMediaFile(this.$refs.cert_bg, 'cert_bg');
        if (cert_bg !== null) {
            this.course.cert_bg = cert_bg;
        }

        const cert_detail_bg = await this.saveMediaFile(this.$refs.cert_detail_bg, 'cert_detail_bg');
        if (cert_detail_bg !== null) {
            this.course.cert_detail_bg = cert_detail_bg;
        }

        const cert_sharing_bg = await this.saveMediaFile(this.$refs.cert_sharing_bg, 'cert_sharing_bg');
        if (cert_sharing_bg !== null) {
            this.course.cert_sharing_bg = cert_sharing_bg;
        }
    }

    public async saveMediaFile(
        field: any,
        fieldName: string
    ): Promise<number | null | undefined> {
        if (!this.course || !this.course.id) {
        return null;
        }
        const mediaFileField = (field as any) as MediaFileField;
        console.log('mediaFileField >> ', mediaFileField);
        
        if (mediaFileField.hasNewMedia()) {
        return await mediaFileField.upload(Courses.SLUG, this.course.id, fieldName);
        } else if (!mediaFileField.hasMedia()) {
        return undefined;
        } else {
        return null;
        }
    }
}
